import { render } from "./FourElements.vue?vue&type=template&id=001666bf&scoped=true"
import script from "./FourElements.vue?vue&type=script&lang=js"
export * from "./FourElements.vue?vue&type=script&lang=js"

import "./FourElements.vue?vue&type=style&index=0&id=001666bf&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001666bf"]])

export default __exports__